import React, { useState, useEffect } from "react";
import api from "services/api";
import { __ } from "services/Translator";

// Player-facing spend / activity summary — deposited, withdrawn, net, wagered and
// win/loss over rolling windows, in the player's own currency. Consumes the
// Responsible-Gaming engine endpoint GET /rg/spend-activity (gated server-side
// behind the RG flag; when off the call 422s and this renders its empty state).
const RANGES = [
  { key: "7d", label: "Last 7 days" },
  { key: "30d", label: "Last 30 days" },
  { key: "90d", label: "Last 90 days" },
];

export default function SpendActivity(props) {
  const [data, setData] = useState(null);
  const [range, setRange] = useState("30d");
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (props.setSpinner) props.setSpinner(true);
    var response = await api.get("/rg/spend-activity");
    if (props.setSpinner) props.setSpinner(false);
    if (response.status === 200) {
      setData(response.data);
    }
    setLoaded(true);
  };

  useEffect(() => {
    load();
  }, []);

  const currency = data && data.currency ? data.currency : "";
  const money = (v) => (currency ? currency + " " : "") + (v != null ? v : "0.00");
  const row = data && data.ranges ? data.ranges[range] : null;

  return (
    <div className="rg_activity">
      <div className="rg_activity_tabs">
        {RANGES.map((r) => (
          <button
            key={r.key}
            type="button"
            className={"rg_activity_tab" + (range === r.key ? " active" : "")}
            onClick={() => setRange(r.key)}
          >
            {__(r.label)}
          </button>
        ))}
      </div>

      {row ? (
        <div className="rg_activity_grid">
          <div className="rg_activity_tile">
            <span className="rg_activity_label">{__("Deposited")}</span>
            <b>{money(row.deposited)}</b>
          </div>
          <div className="rg_activity_tile">
            <span className="rg_activity_label">{__("Withdrawn")}</span>
            <b>{money(row.withdrawn)}</b>
          </div>
          <div className="rg_activity_tile">
            <span className="rg_activity_label">{__("Net deposited")}</span>
            <b>{money(row.net_deposited)}</b>
          </div>
          <div className="rg_activity_tile">
            <span className="rg_activity_label">{__("Total wagered")}</span>
            <b>{money(row.wagered)}</b>
          </div>
          <div className="rg_activity_tile">
            <span className="rg_activity_label">{__("Win / loss")}</span>
            <b className={parseFloat(row.win_loss) >= 0 ? "rg_pos" : "rg_neg"}>{money(row.win_loss)}</b>
          </div>
        </div>
      ) : (
        <p className="rg_activity_empty">
          {loaded ? __("No activity to show for this period yet.") : __("Loading your activity…")}
        </p>
      )}

      <p className="rg_activity_note">
        <small>{__("Figures cover the selected period and are shown in your account currency.")}</small>
      </p>
    </div>
  );
}
